import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface DailyMemoResponse {
    memo_date: string;
    contents: string;
    m_name: string | null; // 최종 수정자
    update_date: string | null; // 'YYYY.MM.DD HH:mm'
}

/*
// 일자별 공유 메모 조회
// 기록이 없는 날짜도 빈 메모로 내려오므로 호출부에서 분기할 필요가 없다.
*/
export const useGetDailyMemo = (memo_date: string): UseQueryResult<DailyMemoResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<DailyMemoResponse, Error>({
        queryKey: ["getDailyMemo", memo_date],
        enabled: !!memo_date,
        queryFn: async () => {
            const response = await axios.get(enum_api_uri.daily_memo, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params: { memo_date },
            });
            return response.data.data;
        },
    });
};
